import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import {
  Container,
  FormControl,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Switch,
  Typography,
} from "@mui/material";
import Select from "@mui/material/Select";
import { fetchApplicationDetailsAgeRating } from "../../Services/redux/ApplicationDetailsAgeRatings/ApplicationDetailsAgeRatingsActions";
import { getConfig } from "../../config";
import "./ApplicationDetailsAgeRatingAds.css";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 18,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(15.5px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#1890ff",
        ...theme.applyStyles("dark", {
          backgroundColor: "#177ddc",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));

function ApplicationDetailsAgeRatingAds({ postCallTheNewSubmission }) {
  const dispatch = useDispatch();
  const [ads, setAds] = useState(false);
  const [appContentRating, setAppContentRating] = useState(false);
  const [selectedAgeRating, setSelectedAgeRating] = useState("");
  const [ageRatingValue, setAgeRatingValue] = useState("");
  const [allAgeRating, setAllAgeRating] = useState([]);

  const submissionData = useSelector(
    (state) => state.submissionDetails.submissionDetails,
  );

  const applicationDetailsAgeRatingData = useSelector(
    (state) => state.appDetailsAgeRatings.applicationDetailsAgeRatings,
  );

  useEffect(() => {
    if (submissionData && Object.keys(submissionData).length > 0) {
      if (getConfig().REACT_APP_PORTAL === "seller") {
        dispatch(fetchApplicationDetailsAgeRating());
      }
      setAds(submissionData?.containAds);
      setAppContentRating(submissionData?.isAgeRatingsEnabled);
      setSelectedAgeRating(submissionData?.ageAppropriateRating?.ageRating);
      setAgeRatingValue(submissionData?.ageAppropriateRating);

      if (getConfig().REACT_APP_PORTAL === "seller") {
        if (submissionData?.isAgeRatingsEnabled) {
          setSelectedAgeRating(submissionData.ageAppropriateRating.ageRating);
        }
      } else if (
        getConfig().REACT_APP_PORTAL === "oem-admin" &&
        submissionData.ageAppropriateRating &&
        Object.keys(submissionData.ageAppropriateRating).length > 0
      ) {
        setSelectedAgeRating(
          submissionData.ageAppropriateRating?.ageRating || "",
        );
      }
    }
  }, [submissionData]);

  useEffect(() => {
    if (
      applicationDetailsAgeRatingData &&
      applicationDetailsAgeRatingData.length > 0
    ) {
      setAllAgeRating([...applicationDetailsAgeRatingData]);
      setSelectedAgeRating(
        submissionData?.ageAppropriateRating
          ? submissionData.ageAppropriateRating.ageRating
          : "",
      );
    }
  }, [applicationDetailsAgeRatingData]);

  const handleContentRatingChange = (event) => {
    setSelectedAgeRating(event.target.value.trim());
    const selectedAgeRatingData = allAgeRating.find((item) => item.ageRating === event.target.value.trim());
    let newSubmissionData = {
      ...submissionData,
      ageAppropriateRating: {
        ageRating: selectedAgeRatingData.ageRating,
        helpText: selectedAgeRatingData.helpText,
        iconUrl: selectedAgeRatingData.iconUrl,
        iconSha256Hash: selectedAgeRatingData.iconSha256Hash,
      },
    };
    delete newSubmissionData["legalDocuments"];
    postCallTheNewSubmission(newSubmissionData);
  };

  const handleAdsChange = ($event) => {
    let newSubmissionData = {
      ...submissionData,
      containAds: $event.target.checked,
    };
    setAds($event.target.checked);
    delete newSubmissionData["legalDocuments"];
    postCallTheNewSubmission(newSubmissionData);
  };

  if (!submissionData || Object.keys(submissionData).length === 0) {
    return null;
  }

  return (
    <Container maxWidth="lg" style={{ marginBottom: "16px" }}>
      <div>
        <div>
          <section
            id="ageRatingAds"
            className="rollout"
            style={
              submissionData.status === "DRAFT"
                ? { marginBottom: "20px !important", width: "85%" }
                : { marginBottom: "20px !important" }
            }
          >
            <Typography
              sx={{
                "font-weight": "bold !important",
                "font-size": "20px !important",
                color: "rgba(18, 20, 21, 1) !important",
                "margin-right": "auto !important",
              }}
              className="uploadSignedApkText"
            >
              App Content Rating & Ads
            </Typography>
            <div className="rollout-wrapper" style={{ marginTop: "15px" }}>
            
                <div className="ads-section">
                  <div className="wrapper-diver">
                    <p className="auto-text">Ads</p>
                    <div style={{ marginRight: "15px" }}>
                      <AntSwitch
                        checked={ads}
                        onChange={handleAdsChange}
                        disabled={submissionData.status !== "DRAFT"}
                      />
                    </div>
                  </div>
                  <p className="rollout-overview">
                    Let us know whether your app contains ads. This includes ads
                    delivered by third-party ad networks. Make sure that this
                    information is accurate and is kept up to date.
                  </p>
                </div>
              

           
                <div className="ageRating-section">
                  <div className="wrapper-diver">
                    <p className="auto-text">App Content Rating</p>
                    <div style={{ marginRight: "15px" }} />
                  </div>
                  <p className="rollout-overview">
                    Assign a suitable IARC age-based rating indicating
                    acceptable audiences for your game content, ranging from
                    Ages 3+ to Ages 18+, ensuring responsible distribution and
                    user appreciation. Default: Everyone, app developer can
                    select appropriate age rating for the app to be published
                  </p>
                  {(getConfig().REACT_APP_PORTAL === "seller"
                    ? allAgeRating &&
                      allAgeRating.length > 0 &&
                      submissionData.ageAppropriateRating
                    : (appContentRating &&
                        allAgeRating &&
                        allAgeRating.length > 0) ||
                      submissionData.ageAppropriateRating) && (
                    <p
                      className="rollout-overview"
                      style={{ marginTop: "16px" }}
                    >
                      <FormControl
                        fullWidth
                        sx={{ marginBottom: "20px !important", width: "376px" }}
                      >
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={selectedAgeRating || ""}
                          onChange={handleContentRatingChange}
                          sx={{ height: "46px !important;" }}
                          disabled={submissionData.status !== "DRAFT"}
                          renderValue={(selected) => {
                            const selectedRating =
                              getConfig().REACT_APP_PORTAL === "seller"
                                ? applicationDetailsAgeRatingData.find(
                                    (item) => item.ageRating === selected,
                                  )
                                : ageRatingValue;

                            if (!selectedRating) return selected;

                            return (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={selectedRating.iconUrl}
                                  alt={selectedRating.ageRating}
                                  style={{
                                    width: "24px",
                                    height: "32px",
                                    marginRight: "12px",
                                  }}
                                />
                                <span>Ages {selectedRating.ageRating}</span>
                              </div>
                            );
                          }}
                        >
                          {getConfig().REACT_APP_PORTAL === "seller"
                            ? applicationDetailsAgeRatingData.map((agRting) => (
                                <MenuItem key={agRting.ageRating} value={agRting.ageRating}>
                                  <ListItem sx={{ paddingLeft: "0px" }}>
                                    <ListItemIcon sx={{ minWidth: 30 }}>
                                      <img
                                        src={agRting.iconUrl}
                                        alt={agRting.ageRating}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={`Ages ${agRting.ageRating}`}
                                      secondary={agRting.helpText}
                                    />
                                  </ListItem>
                                </MenuItem>
                              ))
                            : null}
                          {getConfig().REACT_APP_PORTAL !== "seller" && ageRatingValue?.ageRating && (
                            <MenuItem key={ageRatingValue.ageRating} value={ageRatingValue.ageRating}>
                              <ListItem sx={{ paddingLeft: "0px" }}>
                                <ListItemIcon sx={{ minWidth: 30 }}>
                                  <img
                                    src={ageRatingValue.iconUrl}
                                    alt={ageRatingValue.ageRating}
                                  />
                                </ListItemIcon>
                                <ListItemText
                                  primary={`Ages ${ageRatingValue.ageRating}`}
                                  secondary={ageRatingValue.helpText}
                                />
                              </ListItem>
                            </MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </p>
                  )}
                </div>
            </div>
          </section>
        </div>
      </div>
    </Container>
  );
}

ApplicationDetailsAgeRatingAds.propTypes = {
  postCallTheNewSubmission: PropTypes.func.isRequired,
};

export default ApplicationDetailsAgeRatingAds;
